import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoadingButton } from "@mui/lab";
import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AddBankAccount,
  fetchBankAccounts,
  filterBanks,
  getHmoData,
  setPagination,
  updateBankAccount,
} from "../../../../features/hmo/hmoSlice";

import { useEffect } from "react";
import SelectInput from "../../../../components/SelectInput";
import HomeLayout from "../../../../layouts/Home";
import { getIds } from "../../../../utils/helper";
import { vaddBankAccount } from "../../../../utils/validators";

const AddHmoAccount = () => {
  let navigate = useNavigate(),
    { bankAccounts, banksLoading, pagination } =
      useSelector(getHmoData),
    { state } = useLocation(),
    dispatch = useDispatch(),
    {
      values,
      handleBlur,
      handleChange,
      handleFocus,
      handleSubmit,
      errors,
      setValues,
      touched,
      isSubmitting,
    } = useFormik({
      validationSchema: vaddBankAccount,
      initialValues: { accountName: "", accountNumber: "", bank: "" },
      onSubmit: async (values) => {
        try {
          const action = state ? updateBankAccount : AddBankAccount;
          const payload = values;
          if (typeof values.bank === "string") {
            payload.bankId = bankAccounts.find(
              (b) => b.name === values.bank
            ).id;
          }
          payload.hmoId = getIds()?.hmo;
          if (state) payload.bankAccountId = state.id;
          const res = await dispatch(action(payload)).unwrap();
          res?.success === true && navigate(-1);
        } catch (error) {
          console.error(error);
        }
      },
    });

  function handleSearch(e) {
    e.stopPropagation();
    const {
      target: { value },
    } = e;
    let cb = null;
    if (value) {
      dispatch(filterBanks(value));
    } else if (cb) {
      dispatch(fetchBankAccounts());
      clearTimeout(cb);
    } else dispatch(fetchBankAccounts());
  }

  useEffect(() => {
    dispatch(setPagination({ search: "" }));
    dispatch(fetchBankAccounts());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state) {
      setValues({
        accountName: state.accountName || "",
        accountNumber: state.accountNumber || "",
        bank: state.bank || "",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <HomeLayout {...{ title: "Configuration" }}>
      <Box className="flex text-[var(--c-dark-1)]">
        <ArrowBackIcon
          onClick={(_) => navigate(-1)}
          className=" mr-2 cursor-pointer"
          fontSize="small"
        />
        <Typography className="text-[400] text-[16px] ">Go back</Typography>
      </Box>
      <Typography className="text-[400] text-xl mt-8 text-[#040316]">
        {state ? "Edit Account" : "New Account"}
      </Typography>
      <Box
        className="w-[100%] rounded-lg"
        sx={{
          px: "3em",
          py: "3em",
          bgcolor: "var(--c-bg-color)",
          mt: "3%",
        }}
        component="form"
        noValidate
        onSubmit={handleSubmit}
      >
        <Box className="grid lg:grid-cols-2 gap-4 mb-8">
          <FormControl className="w-full border-none lg:mt-5">
            <TextField
              className="w-full bg-white"
              id="accountName"
              label="Account Name"
              name="accountName"
              value={values.accountName}
              onFocus={handleFocus}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.accountName && touched.accountName}
              helperText={
                errors.accountName && touched.accountName
                  ? errors.accountName
                  : ""
              }
            />
          </FormControl>
          <FormControl className="w-full border-none lg:mt-5">
            <TextField
              className="w-full bg-white"
              id="accountNumber"
              label="Account Number"
              name="accountNumber"
              value={values.accountNumber}
              required
              onFocus={handleFocus}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.accountNumber && touched.accountNumber}
              helperText={
                errors.accountNumber && touched.accountNumber
                  ? errors.accountNumber
                  : ""
              }
            />
          </FormControl>
          <SelectInput
            {...{
              className: "w-full mx-auto ",
              options: bankAccounts?.map(({ name }) => name),
              value: values.bank || "",
              label: "Bank Name",
              name: "bank",
              required: true,
              handleBlur,
              handleFocus,
              handleChange,
              handleSearch,
              loading: !pagination.search && banksLoading,
              searchLoading: pagination.search && banksLoading,
              error: errors.bank && touched.bank,
              helperText: errors.bank,
            }}
          />
        </Box>
        <Box className="flex justify-end gap-4 my-6">
          <Button
            className="w-[213px] h-[56px] bg-[var(--cc-grey-3)] text-[var(--c-primary-0)] text-[18px] rounded-xl shadow-none normal-case"
            size="small"
            type="button"
            variant="contained"
            fullWidth
            onClick={(_) => navigate(-1)}
          >
            Cancel
          </Button>
          <LoadingButton
            className="w-[213px] h-[56px] bg-[var(--c-primary-0)] text-[18px] rounded-xl shadow-none normal-case"
            sx={{
              ".MuiLoadingButton-loadingIndicatorCenter": {
                color: "var(--c-bg-color) !important",
              },
            }}
            type="submit"
            size="small"
            variant="contained"
            fullWidth
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {state ? "Save" : "Add Account"}
          </LoadingButton>
        </Box>
      </Box>
    </HomeLayout>
  );
};

export default AddHmoAccount;
